import React, { useMemo } from 'react';
import LoadingIcon from '@appmaker/components/LoadingIcon';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { LineChart, BarChart } from './Charts';

// Optimized DataView component with memoization
const DataView = React.memo(({
	title,
	dateRange,
	className,
	chartMarkers = [],
	headerRight,
	isLoading = false,
	chartType = 'line',
	chartData = [],
}) => {
	const formattedDateRange = useMemo(() => ({
		start: dateRange?.startDate ? dayjs(dateRange.startDate).format('MMM DD, YYYY') : '',
		end: dateRange?.endDate ? dayjs(dateRange.endDate).format('MMM DD, YYYY') : '',
	}), [dateRange]);

	const hasData = chartData && chartData.length > 0 && chartMarkers?.length > 0;

	return (
		<div className={clsx('border border-gray-200 rounded-lg p-4', className)}>
			<div className="flex flex-row justify-between items-center">
				<h3 className="text-lg font-medium text-gray-900">{title}</h3>
				<div className="flex flex-row gap-4 items-center">
					<h3 className="text-sm text-gray-500">
						{formattedDateRange.start} - {formattedDateRange.end}
					</h3>
					{headerRight}
				</div>
			</div>
			<div className="h-64 flex flex-col justify-center items-center my-4">
				{isLoading ? (
					<LoadingIcon className="w-6 h-6 text-blue-500 animate-spin" />
				) : hasData ? (
					chartType === 'line' ? (
						<LineChart data={chartData} markers={chartMarkers} />
					) : (
						<BarChart data={chartData} markers={chartMarkers} />
					)
				) : (
					<small>No data available for the selected period.</small>
				)}
			</div>
			{hasData && (
				<div className="flex flex-row items-center justify-end space-x-4">
					{chartMarkers.map((marker, index) => (
						<div key={index} className="flex flex-row gap-2 items-center">
							<div
								className="w-3 h-3"
								style={{ backgroundColor: marker.color }}
							/>
							<small>{marker.name}</small>
						</div>
					))}
				</div>
			)}
		</div>
	);
});

DataView.displayName = 'DataView';

export default DataView; 